import React, { useEffect } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import * as Comp from "./StyledCourseDiscSection";
import { Fade } from "react-reveal";
import DepartmentCourse from "../DepartmentCourse";
import AboutTeacher from "../AboutTeacher";
import { useSelector } from "react-redux";
import RatingsModule from "../../ratings/feature/RatingsModule";
import AddRatingModule from "../../ratings/feature/AddRatingModule";
import {
  useGetCourseRatesQuery,
  useAddCourseMutation,
} from "../../ratings/service/RatingService";
import { useParams } from "react-router-dom";
import TotalRates from "../../ratings/components/TotalRates";
import { Wrapper } from "../../ratings/components/Wrapper";
import { WorkingPapers } from "../WorkingPapers";

const CourseDiscSection = ({ teacherId, dataDepartments, LoadDepartments }) => {
  const [value, setValue] = React.useState(0);
  const dataToken = useSelector((state) => state.Auth.userInfo.token);
  const { idCourse } = useParams();

  const { data: courseRateData } = useGetCourseRatesQuery(idCourse, dataToken);
  const addCourseRate = useAddCourseMutation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }
  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  }
  return (
    <div style={{ height: "130vh" }}>
      <Comp.Section>
        <Comp.RightSection>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              scrollButtons
              value={value}
              allowScrollButtonsMobile
              onChange={handleChange}
              variant="scrollable"
              aria-label="lab API tabs example"
            >
              <Tab label={"حول الدورة"} {...a11yProps(0)} />
              <Tab label={"أوراق العمل"} {...a11yProps(1)} />
              <Tab label={" نبذة عن المدرس "} {...a11yProps(2)} />
              {dataToken && <Tab label={"تقييم الدّورة"} {...a11yProps(3)} />}
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <Fade>
              <DepartmentCourse
                data={dataDepartments}
                loader={LoadDepartments}
              />
            </Fade>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Fade>
              <WorkingPapers data={dataDepartments} loader={LoadDepartments} />
            </Fade>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Fade>
              <AboutTeacher id={teacherId} />
            </Fade>
          </TabPanel>

          {dataToken && (
            <TabPanel value={value} index={3}>
              <Fade>
                <Wrapper>
                  {/* <TotalRates
                    numberOfRater={courseRateData?.number_of_rater}
                    rate={courseRateData?.rate}
                  /> */}

                  <AddRatingModule
                    sessionId={idCourse}
                    addRate={addCourseRate.mutate}
                    isLoading={addCourseRate.isLoading}
                    isSuccess={addCourseRate.isSuccess}
                    placeholder={"اكتب تقييمك هنا"}
                    type={"course"}
                  />
                  <RatingsModule rateData={courseRateData} />
                </Wrapper>
              </Fade>
            </TabPanel>
          )}
        </Comp.RightSection>
      </Comp.Section>
    </div>
  );
};

export default CourseDiscSection;
